<template>
  <div class="mt-8 push-web-responsive-note">

    <ValidationObserver v-slot="{ invalid }">
      <v-card class="filter--container d-flex">
        <div class="button-wrapper d-flex justify-space-between">

          <ValidationProvider class="form-group" rules="required">
            <span class="d-flex flex-row filterContainer">
              <v-select v-model="selected" type=" text" placeholder="Selecione uma opção" class="inputTypeFilter"
                :options="options">
              </v-select>

              <input v-model="search" :disabled="invalid" required type="text" placeholder="Buscar"
                class="inputTypeSearch">
            </span>
          </ValidationProvider>
        </div>

        <div class="buttonContainer button-wrapper d-flex justify-space-between">
          <button @click="getUsersFiltered" class="mr-5" :disabled="disabled">
            <clip-loader v-if="loading" :loading="loading" color="var(--white)" size="22px" />
            <div v-if="!loading" class="button-wrapper--text">
              <img src="../../../../static/images/search.svg">
              Buscar
            </div>
          </button>

          <button @click="clearForm" style="background: var(--white); border: 1px solid grey; color: var(--dark-grey)">
            <clip-loader v-if="loadingClear" :loading="loadingClear" color="var(--black)" size="22px" />
            <div v-if="!loadingClear" class="button-wrapper--text">
              <img src="../../../../static/images/load.svg">
              Limpar
            </div>
          </button>
        </div>
      </v-card>
    </ValidationObserver>

    <div v-if="!loadingData">
      <v-expansion-panels class="mt-5">
        <v-expansion-panel v-for="(item, index) in users" :key="index" class="mt-2 d-flex flex-column rounded-lg"
          height="59" id="expansion-item">
          <v-expansion-panel-header class="d-flex align-center">
            <template v-slot:actions>
              <v-icon>
                mdi-alert-circle
              </v-icon>
            </template>
            <span class="rounded borderLeft" style=""></span>
            <div class="d-flex align-center justify-space-between">
              <v-col>
                {{ item.name }}
                <v-col>
                  <v-row class="mt-0">
                    <small>Status do usuário: </small>
                    <strong style="font-size:12px">
                      <v-icon v-if="item.status == 'ATIVO'" small color="success">mdi-check-circle</v-icon>
                      <v-icon v-if="item.status == 'BLOQUEADO'" small color="error">mdi-cancel</v-icon>
                      <v-icon v-if="item.status == 'INATIVO'" small color="warning">mdi-minus-circle</v-icon>
                      <v-icon v-if="item.status == 'PASSWORD_BLOQUEADO'" small color="default">mdi-account-lock
                      </v-icon>
                      {{ item.status }}
                    </strong>
                  </v-row>
                </v-col>
              </v-col>
              <v-col>
                {{ item.email }}
              </v-col>
              <div class="d-flex align-center justify-space-between">
                <div class="buttons_action">

                  <button style="
                        border: 2px solid var(--grey-day-020);
                        height: 40px;
                        width: 40px;
                      " class="b-4 d-flex justify-center align-center" @click="setDuplicateForm(item)">
                    <img src="../../../../static/images/edit.svg" />
                  </button>
                </div>
              </div>
            </div>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div v-if="noResults && !loadingData" class="mt-5 d-flex justify-center align-center rounded"
      style="background: var(--white); width: auto; height: 200px">
      <span>Nenhum registro encontrado!</span>
    </div>

    <div v-if="loadingData" class="m-auto text-center p-4">
      <h1><strong>Gerencie os usuários do sistema.</strong></h1>
      <h3>Selecione uma das opções para começar a filtragem.</h3>
      <img src="@/assets/svg/seo.svg" alt="Imagem Destacada" class="highlight--image p-3">
    </div>


    <v-card class="mt-8">
      <div v-if="!loadingData" class="list-footer">
        <span></span>
        <v-pagination v-model="page" :length="pagination.totalPages - 1" color="#F0F1F3" :total-visible="7"
          @input="nextPage">
        </v-pagination>
        <div class="goToPage">
          <span class="goToPage--text">
            Ir para página
          </span>
          <label>
            <input v-model="goToPage" type="text">
            <button @click="goToPageRequest">
              <div class="button-wrapper--text">
                <i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
              </div>
            </button>
            <span :class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'" class="goToPage--helptext">
              A página deve estar entre 0 e {{ pagination.totalPages - 1 }}
            </span>
          </label>
        </div>
      </div>
    </v-card>
    <div style="height: 5px"></div>
    <v-navigation-drawer v-model="drawer" fixed overlay temporary right width="620" height="100vh"
      style="background: var(--grey-day-010)">
      <ListManagementEdit v-on:close="drawer = false" />
    </v-navigation-drawer>
  </div>
</template>
<script>
// Libs
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import { mapActions, mapMutations, mapState } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'

//
import VueCookies from 'vue-cookies'

// Component
import ListManagementEdit from '@/components/Contents/ScheduleWeb/ListManagementEdit'

//mixins
import date from '../../../mixins/date'
import toaster from '../../../mixins/toaster'

export default {
  mixins: [date, toaster],
  components: {
    DatePicker,
    ClipLoader,
    ListManagementEdit,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      options: [
        { value: 'email', label: 'E-mail' },
        { value: 'name', label: 'Nome' },
        { value: 'acta_user_id', label: 'Acta ID' },
        // { value: 'status', label: 'Status do Usuário'}
      ],
      disabled: true,
      loading: false,
      size: 10,
      page: 0,
      goToPage: 0,
      disabledGoTo: false,
      showGoToPageHelpText: false,
      selected: null,
      email: "",
      search: "",
      drawer: false,
      loadingClear: false,
      loadingData: true,
      noResults: false,
    };
  },
  computed: {
    ...mapState('UserManagement', {
      users: 'usersList',
      userActaId: 'userActaId',
      pagination: "totalPages",
      currentPage: "current_page",
      numPages: "totalPages",
    }),
    ...mapState('UserManagement', [
      'groupAssignment',
      'usersGroupsList',
    ]),
    numberPages() {
      return this.totalPages
    },
    widthScreen() {
      return window.screen.width > 1377;
    },
  },
  methods: {
    ...mapActions(
      "UserManagement", [
      "getUsers",
      "getUsersByEmail",
      "getUsersByName",
      "getUsersActaId",
      "getListFromUser"
    ]
    ),
    ...mapMutations("UserManagement", {
      setCurrentPage: "SET_CURRENT_PAGE",
      totalPages: "SET_TOTAL_PAGE",
      setUserToAssign: "SET_ASSIGN_GROUP_TO_EDIT",
      unsetGroupList: 'UNSET_USER_NEW_GROUPS',

    }),
    async getUsersFiltered() {
      this.loadingData = true
      this.loading = true
      if (this.selected.value === 'email') {
        const token = VueCookies.get('jwt-login')
        await this.getUsersByEmail({
          page: this.page,
          size: this.size,
          search: this.search,
          token: token
        })
        if (this.users.length == 0) {
          this.noResults = true
        } else {
          this.noResults = false
        }
        this.loading = false
        this.loadingData = false
        this.disabled = false
      }
      else if (this.selected.value === 'acta_user_id') {
        const token = VueCookies.get('jwt-login')
        await this.getUsersActaId({
          search: this.search,
          token: token
        })
        if (this.users.length === 0) {
          this.noResults = true
        }
        this.loading = false
        this.loadingData = false
        this.disabled = false
        this.pagination.totalPages = 0
      }
      else if (this.selected.value === 'name') {
        const token = VueCookies.get('jwt-login')
        await this.getUsersByName({
          page: this.page,
          size: this.size,
          search: this.search,
          token: token
        })
        if (this.users.length === 0) {
          this.noResults = true
        } else {
          this.noResults = false
        }
        this.loading = false
        this.loadingData = false
        this.disabled = false
      }
    },
    async clearForm() {
      this.disabled = true
      this.search = null,
        this.selected = null
      this.goToPage = 0
      this.page = 0
      this.loadingData = true
      this.noResults = false
    },
    async nextPage() {
      this.goToPage = this.page
      this.loading = false
      const token = VueCookies.get('jwt-login')
      await this.getUsersFiltered({
        page: this.page,
        size: this.size,
        search: this.search,
        token: token
      })
    },
    async goToPageRequest() {
      this.loadingData = true;
      this.setCurrentPage(Number(this.goToPage));
      const token = VueCookies.get('jwt-login')
      this.page = Number(this.goToPage - 1);
      await this.getUsersFiltered({
        page: this.page - 1,
        size: this.size,
        search: this.search,
        token: token
      });
      this.loadingData = false;
    },
    async setDuplicateForm(item) {
      this.drawer = !this.drawer
      this.setUserToAssign(item)
      this.unsetGroupList()
      const token = VueCookies.get('jwt-login')
      await this.getListFromUser({
        acta_user_id: item.acta_user_id,
        token
      })
      this.loadingData = false;
      this.loading = false
    },
  },
  watch: {
    'goToPage'() {
      if (this.goToPage === null || this.goToPage > this.pagination.totalPages) {
        this.showGoToPageHelpText = true;
        this.disabledGoTo = true;
      } else {
        this.showGoToPageHelpText = false;
        this.disabledGoTo = false;
      }
    },
    'search'() {
      this.selected === null && this.search === null && this.search === ''
        ? (this.disabled = true)
        : (this.disabled = false)
    }
  }
};
</script>
<style lang="scss" scoped>
.push-web-responsive-note {
  width: 1224px;
  .buttons_action {
    display: flex;
    justify-content: flex-end;
  }

  .vs__selected-options {
    width: 250px;
    padding-right: 3px;
  }

  .v-expansion-panel-header {
    padding: 7px 10px 7px 3px;
  }

  .v-expansion-panel-header i {
    display: none;
  }

  .filter--container {
    background: var(--white);
    border-radius: 4px;
    margin-bottom: 3.125rem;
    padding: 1.375rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    min-height: 100px;

    .inputWidth {
      width: 30vw;
    }

    label:focus-within {
      border: 2px solid var(--grey);
    }

    .button-wrapper {
      display: flex;
      justify-content: flex-end;

      &--text {
        display: flex;
        align-items: center;
      }

      button {
        background: var(--dark-red);
        border: none;
        border-radius: 4px;
        color: var(--white);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--dm-sans-medium);
        font-size: 1rem;
        padding: 0.875rem;
        min-height: 48px;
        width: 130px;

        img {
          margin-right: 0.875rem;
        }
      }

      button:disabled {
        background: #dddddd;
        cursor: not-allowed;
      }
    }
  }

  .b-4 {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
  }

  .h-48 {
    height: 48px;
  }

  .vs__dropdown-toggle {
    border: none !important;
  }

  .vs__search {
    display: flex;
    align-items: center;
    padding: 7px;
    color: var(--dark-grey)
  }
  .iconStyle {
    width: 20px;
    height: 20px;
    background: transparent;
  }

  .borderLeft {
    height: 49px;
    max-width: 3px !important;
    width: 13px;
    background-color: var(--green);
    margin: 0 5px;
    position: absolute;
  }

  .v-expansion-panel--active .borderLeft {
    height: initial !important;
    // max-width: 3px !important;
    transition: 0.3s;
    width: 4px;
    background-color: var(--green);
    margin: 0px 5px;
    position: absolute;
    top: 9px;
    bottom: 9px;
  }
}
// .v-slide-group__wrapper{
//   border: 2px solid red;
//   background: pink;
//   margin: 150px
// }
.v-application .widthResponsive {
  width: 10%;
  margin-left: 50px;
}

.filterContainer {
  width: 720px;
}

.inputTypeFilter {
  padding: 7px;
  margin-right: 20px;
  height: 48px;
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  width: 50%;
}

.inputTypeSearch {
  padding: 7px;
  margin-right: 20px;
  height: 48px;
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  width: 100%;
}

.highlight--image {
  width: 250px;
}

.v-pagination__navigation,
.v-pagination__item {
  border: none;
  box-shadow: none;
}

.list-footer {
  background: var(--white);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 2.625rem;
  margin: 80px 0 10px 0;
  height: 64px;
}

.goToPage {
  &--text {
    font-size: 14px;
    font-family: var(--dm-sans-regular);
    color: var(--dark-grey);
    margin-right: 20px;
  }

  label {
    border: 2px solid var(--grey-day-030);
    background: var(--white);
    border-radius: 4px;
    box-sizing: border-box;
    max-width: 84px;
    width: 80px;
    padding: 10px;
    position: relative;

    input {
      width: 54px;
      font-size: 1rem;
      color: var(--grey);
      font-family: var(--dm-sans-regular);
    }

    button {
      position: absolute;
      border-radius: 50%;
      border: none;
      padding: 0;
      top: 11px;
      right: 8px;
      background: var(--grey);
      cursor: pointer;

      i {
        color: var(--white);
        font-size: 1.25rem;
      }
    }

    button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  &--helptext {
    font-family: var(--dm-sans-regular);
    position: absolute;
    font-size: 12px;
    width: 120px;
    text-align: center;
    top: -55px;
    left: -24px;
    background: var(--dark-red);
    padding: 8px;
    color: var(--light-grey);
    border-radius: 4px;
  }

  .--hide-helptext {
    display: none;
  }

  .--show-helptext {
    display: block;
  }
}


@media screen and (max-width: 1377px) {
  .v-application {
    .widthResponsive {
      margin-top: 0;
    }

    .push-web-responsive-note {
      width: 80vw;

      .filter--container {
        height: initial;

        .filterContainer {
          width: 500px;
          display: flex;
        }

        .inputTypeSearch {
          padding: 7px;
          margin-right: 20px;
          height: 48px;
          border: 2px solid var(--grey-day-030);
          border-radius: 4px;
          width: 100%;
        }

        .inputTypeFilter {
          width: 47%;
        }
        .buttonContainer {
          width: 40%
        }

        &.d-flex {
          display: grid !important;
          grid-template-columns: 1fr 1fr;
          gap: 2px;
        }

        // .button-wrapper {
        //   // justify-self: flex-start;
        //   width: 15vw;
        //   border: 1px solid red;
        // }



        .v-expansion-panel--active {
          .borderLeft {
            height: 320px;
          }
        }
      }
    }

    .push-web-responsive-note {


      .widthResponsive {
        width: 200px;
      }

      .imgResponsive {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/ListManagement.vue